import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { StandingDataItemModel } from "@app/standing-data/models/standing-data-item.model";
import { FormStructureType } from "@app/forms/enums/FormStructureType";
import { IdNameCombination } from "@models/generic/IdNameCombination";
import { FileSaveModel } from "@models/generic/FileSaveModel";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class IncidentMapbackService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/mapback`;

    public getStructureForMapback(type: FormStructureType): Promise<StandingDataItemModel[]> {
        return firstValueFrom(this.httpClient
            .get<StandingDataItemModel[]>(`${this.baseUrl}/mapbackoptions/${type}`));
    }

    public storeIncident(result: IdNameCombination[], files: FileSaveModel[]): Promise<void> {
        const formData = new FormData();

        formData.append("mapback", JSON.stringify(result));

        for (const file of files) {
            formData.append(file.id, file.file);
        }

        return firstValueFrom(this.httpClient.post<void>(this.baseUrl, formData));
    }
}
